import {
  Box,
  Circle,
  Flex,
  HStack,
  Icon,
  Text,
  VStack,
} from "@chakra-ui/react";
import React from "react";
import { BsFillHouseFill } from "react-icons/bs";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaPhoneAlt,
  FaInstagram,
} from "react-icons/fa";
import { GrMail } from "react-icons/gr";
import { Link } from "react-router-dom";
import logo from "../../../images/logo/logo-combined.png";
import aita from "../../../images/footer/aita-img.jpg";
import Toab from '../../../images/footer/toab.png'
import SSLCommerz from "../../../images/SSL-Commerz.jpg";
import usbanglaAir from "../../../images/USBA_logo-English.jpg";

const contactInfo = [
  { title: "Email: reservation@travelchamp.com " },
  { title: "Phone: 01322819380 (GDS)" },
  { title: "Phone: 09613335566 (Hotline)" },
  { title: "Phone: 01701-208460 (Non GDS)" },
];

const quickLinksData = [
  { text: "About Us", to: "aboutus" },
  // { text: "Contact", to: "contact" },
  // { text: "Bank Details", to: "bankdetail" },
  { text: "ADM Policy", to: "Admpolicy" },
  // { text: "EMI Policy", to: "EmiPolicy" },
  { text: "Privacy Policy", to: "privacypolicy" },
  { text: "Terms And Conditions", to: "termandcondition" },
  { text: "Refund & Cancellation", to: "refundandcancellation" },
  {
    text: "Travel Documents Requirements",
    to: "https://www.iatatravelcentre.com/passport-visa-health-travel-document-requirements.htm",
  },
  { text: "Booking Policy", to: "bookingpolicy" },
];

const addressData = [
  {
    type: "address",
    text: `Sharif Plaza (5th Floor), 39 Kemal Ataturk Avenue,
Banani, Dhaka-1213`,
    link: "https://maps.app.goo.gl/DLrV8EpyiGuv6xUR6",
    icon: BsFillHouseFill,
  },
  {
    type: "email",
    text: [
      "reservation@travelchamp.com",
      // "info@travelchamp.com",
      // "holiday@travelchamp.com",
      // "group@travelchamp.com",
      // "pd@travelchamp.com",
    ],
    link: "mailto:reservation@travelchamp.com",
    icon: GrMail,
  },
  {
    type: "phone",
    // text: "01322819380, +8809613335566 ",
    text: "+8809613335566",
    link: "tel:+8809613335566",
    icon: FaPhoneAlt,
  },
];

const Footer = () => {
  return (
    <>
      <Box boxShadow="0px -4px 3px rgba(50, 50, 50, 0.05)" bg="white">
        <Box
          className="container-fluid"
          style={{ paddingLeft: "15%", paddingRight: "15%" }}
        >
          <div
            color={"white"}
            className="row justify-content-between"
            style={{ paddingTop: "20px", paddingBottom: "10px" }}
          >
            {/* <Box className="col-lg-3 col-md-6 p-2">
              <Text fontSize="18px" fontWeight={500} mb="24px" color="primary">
                Accounts and Revenue
              </Text>

              <Text style={{ color: "black" }}>
                Email: revenue@travelchamp.com
              </Text>
              <Text style={{ color: "black" }} mb={"10px"}>
                Phone: 01701208452
              </Text>
              <Text
                fontSize="18px"
                fontWeight={500}
                mt="32px"
                mb="24px"
                color="primary"
              >
                Reservation
              </Text>
              {contactInfo.map((item, idx) => (
                <Box key={idx}>
                  <Text
                    fontSize="14px"
                    fontWeight={400}
                    style={{ color: "black" }}
                  >
                    {item?.title}
                  </Text>
                </Box>
              ))}
            </Box> */}

            <Box className="col-lg-3 col-md-6 p-2">
              <Text fontSize="18px" fontWeight={500} mb="24px" color="primary">
                Contact Us
              </Text>
              {addressData.map((item, idx) => (
                <HStack gap="8px" mb="10px" key={idx} color="black">
                  <Icon as={item.icon} h="26px" w="24px" color="black" />

                  {Array.isArray(item.text) ? (
                    <div className="d-flex flex-wrap">
                      {item.text.map((itm, index) => (
                        <a
                          key={index}
                          style={{
                            fontSize: "14px",
                            fontWeight: 400,
                            maxWidth: "240px",
                          }}
                          href={`mailto:${itm}`}
                        >
                          {itm}
                        </a>
                      ))}
                    </div>
                  ) : (
                    <a
                      href={item.link || "#"}
                      target={item.type === "address" ? "_blank" : "_self"}
                      rel={"noopener noreferrer"}
                      style={{
                        fontSize: "14px",
                        fontWeight: 400,
                        maxWidth: "240px",
                      }}
                    >
                      {item.text}
                    </a>
                  )}
                </HStack>
              ))}
            </Box>

            <Box className="col-lg-3 col-md-6 p-2">
              <Text fontSize="18px" fontWeight={500} mb="24px" color="primary" className="ps-lg-5 ps-0">
                Quick Links
              </Text>
              {quickLinksData.map((item, idx) => {
                return (
                  <div key={idx} className="ps-lg-5 ps-0">
                    {item.text === "Travel Documents Requirements" ? (
                      <>
                        <a href={`${item.to}`} target="_blank">
                          <Text
                            fontSize="14px"
                            fontWeight={400}
                            mb="8px"
                            color="black"
                            _hover={{ color: "primary" }}
                          >
                            {item.text}
                          </Text>
                        </a>
                      </>
                    ) : (
                      <>
                        <Link to={`/${item.to}`} key={idx}>
                          <Text
                            fontSize="14px"
                            fontWeight={400}
                            mb="8px"
                            color="black"
                            _hover={{ color: "primary" }}
                          >
                            {item.text}
                          </Text>
                        </Link>
                      </>
                    )}
                  </div>
                );
              })}
            </Box>

            <Box className="col-lg-3 col-md-6 p-2">
              <VStack>
                <Text fontSize={"20px"} color={"#068B9F"}>
                  Accredited By
                </Text>
                <img
                  src={aita}
                  alt="footerlogo"
                  style={{
                    height: "150px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    marginTop: "5px",
                  }}
                />
              </VStack>
            </Box>

            <Box className="col-lg-3 col-md-6 p-2">
              <VStack>
                <Text fontSize={"20px"} color={"#068B9F"}>
                Member of
                </Text>
                <img
                  src={Toab}
                  alt="footerlogo"
                  style={{
                    height: "150px",
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                    marginTop: "5px",
                  }}
                  className="p-3"
                />
              </VStack>
            </Box>
          </div>
        </Box>
      </Box>

      <Box borderY="1px solid #ededed" className="container-fluid">
        {/* <Box className="container">
          <img
            src={SSLCommerz}
            alt="footerlogo"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "5px",
            }}
          />
        </Box>
        <Text
          style={{
            display: "flex",
            color: "#068B9F",
            justifyContent: "center",
            alignItems: "center",
          }}
          fontWeight={500}
          fontSize={"20px"}
        >
          Concern of
        </Text>
        <Box
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "5px",
          }}
        >
          <img
            src={usbanglaAir}
            alt="footerlogo"
            style={{ height: "100px", width: "300px" }}
          />
        </Box> */}
      </Box>

      <Box
        display={"flex"}
        flexWrap={"wrap"}
        justifyContent="center"
        alignItems="center"
        className="py-3"
      >
        <img src={logo} alt="" width="100px" height={"10px"} />
        <Text
          fontSize="14px"
          fontWeight={400}
          color="#908DAB"
          textAlign="center"
          pl="5px"
        >
          {" "}
          Copyright © 2025 Travelchamp Ltd. All rights reserved.
        </Text>
      </Box>
    </>
  );
};

export default Footer;
